<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="form_wrap">
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">上传人物图片</div>
          </div>
          <div class="Reference_image">
            <el-upload class="upload-demo" drag :action="fileApi + '/api/front/upload/?fdir=mj_tool'"
                       :show-file-list="false" accept="image/jpeg, image/png, image/bmp"
                       :on-success="UpdataSuccess" :before-upload="beforeUpload" multiple>
              <div v-if="form.data.iw_url" class="yesUpload">
                <img :src="form.data.iw_url" alt="" class="yesUpload_img" ref="originImg">
                <img :src="form.data.iw_urls" class="yesUploadMask" v-show="clearMaskShow" alt="">
                <!-- <canvas class="yesUploadMask" v-show="clearMaskShow" ref="yesMask"></canvas> -->
                <div class="yesUpload_icon" @click.stop="openRemovalOther()">
                  重新绘制
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传jpg/png文件，且不超过8MB</div>
              </div>
            </el-upload>
          </div>
        </div>

      </div>
    </div>
    <div class="bottom_area" flex-center>
      <div class="primary_button" @click="sendMsg" v-loading="sending">提交任务 <span>（消耗6积分）</span></div>
    </div>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
    <div class="drowPopB" v-show="isDrowShow">
      <div class="imgRemovalPopup">
        <div class="imgbox_top">
          <div>请擦拭需要涂抹的区域</div>
          <div style="cursor: pointer;" @click="saveImage()"><i class="el-icon-error"></i></div>
        </div>
        <div class="imgbox_center">
          <div class="apply">
            <span @click="toggleMode('draw')" :class="mode == 'draw' ? 'spancol' : ''">涂抹</span>
            <span @click="toggleMode('erase')" :class="mode == 'erase' ? 'spancol' : ''"
                  style="margin-left:10px;">擦拭涂抹</span>
          </div>
          <br/>
          <div class="brush">
            <span>画笔大小</span>
            <div class="slider">
              <el-slider v-model="brushSize"></el-slider>
            </div>
            <div style="width: 20px;">{{ brushSize }}</div>
          </div>
          <div class="brush scoBox">
            <span>比例</span>
            <div class="addBtn" @click="updateScale(0)">
              <img src="../img/jian.svg" alt="">
            </div>
            <div class="aocText">{{ parseInt(scale * 100) }}%</div>
            <div class="addBtn" @click="updateScale(1)">
              <img src="../img/jia.svg" alt="">
            </div>
          </div>
          <div class="clear_btn" @click="clearCanvas()">
            <div>清空</div>
          </div>
        </div>
        <div class="canvas_region">
          <div class="canvas-wrapper">
            <img id="imageOrigin" :src="form.data.iw_url" alt="Image" ref="canvasRecord">
            <canvas ref="canvasDisplay" :width="originWidth" :height="originHeight" id="canMask"></canvas>
          </div>
        </div>
        <div class="complete_btn" @click="saveImage()">
          <div>完成</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      canvasRecord: null, // 保存 canvas 上下文
      canvasDisplay: null, // 保存 canvas 上下文
      clearPath: [],//记录清除轨迹
      screenWidth: 0,
      screenHeight: 0,
      isDrowShow: false,
      brushSize: 10,
      mode: 'draw', // 'draw' 或 'erase'
      opacity: 50,
      scale: 0, // 缩放比例
      originWidth: 0,
      originHeight: 0,
      clearMaskShow: false,//小图遮罩层
      drawnPath: [],
      sending: false,
      upload_img_url: "",
      form: {
        data: {
          iw_url: '',
          iw_urls: ''
        },
        mj_tool: '',
      },
      fileApi: FILE_API_SERVER,
      isWxEnv: false,

      arrange: '',
      relation: '',
      toolList: [
        {
          title: '图片编辑', list: [
            {
              id: 1,
              relation: 0,
              name: '极速高清无损放大',
              guide: '无损放大图片，支持2倍、3倍、4倍放大，有效改善放大后图像的噪点与锯齿问题。',
              img: require('../img/magnify.png'),
              title: '无损放大',
              mj_tool: 'Upscaler',
            },

            {
              id: 2,
              relation: 0,
              name: '黑白图像上色',
              guide: '通过人工智能算法，识别黑白图像内容并填充色彩，使黑白图像变得鲜活。',
              img: require('../img/colour.png'),
              title: '黑白上色',
              mj_tool: 'Colorize',
            },
            {
              id: 3,
              relation: 0,
              name: '图像清晰度增强',
              guide: '利用Ai技术，智能识别图像主体以消除模糊，增强对比度和颜色，获得更清晰、更生动的视觉效果。',
              img: require('../img/repair.png'),
              title: '清晰增强',
              mj_tool: 'SharpnessEnhancement',
            },
            {
              id: 4,
              relation: 0,
              name: '图像风格转换',
              guide: '您可以将图像转换为卡通、铅笔、彩色铅笔或哥特式油画等多种风格。',
              img: require('../img/cartoon.png'),
              title: '风格转换',
              mj_tool: 'Painting',

            },
            {
              id: 5,
              relation: 0,
              name: '图像擦除',
              guide: '快速移除照片中不需要的的物、人、文字。清理照片，美化图片',
              img: require('../img/removelog.png'),
              title: '图像擦除',
              mj_tool: 'imgRemove',
            },


          ],
        },
        {
          title: '电商设计', list: [
            {
              id: 1,
              relation: 1,
              name: '背景移除',
              guide: '智能地识别图像的主体，将其视为前景并自动去除背景。适用于各种场景中的人物、动物等。',
              img: require('../img/capture.png'),
              title: '背景移除',
              mj_tool: 'BackgroundRemoval',
            },

          ],
        },
        {
          title: '创意应用', id: 3, list: [
            {
              id: 1,
              relation: 2,
              name: '头像提取',
              guide: '它能够准确检测头部区域，一键裁剪并去除其他元素。',
              img: require('../img/expansion.png'),
              title: '头像提取',
              mj_tool: 'HeadExtraction',

            },

          ],
        },

      ],
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    }
  },
  created() {
    this.arrange = this.$route.query.arrange
    this.relation = this.$route.query.relation
    this.form.mj_tool = this.toolList[this.relation].list[this.arrange - 1].mj_tool
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
  },
  mounted() {
    setTimeout(() => {
      document.addEventListener('click', this.handleDocumentClick);
      let _form = this.getCache("formAdvanceParams") || ""
      if (_form) {
        this.form = JSON.parse(_form)
      }
    }, 100)
    this.updateScreenSize()
    window.addEventListener('resize', this.updateScreenSize);
  },
  methods: {
    openRemovalOther() {
      this.isDrowShow = true
    },
    toggleMode(name) {
      this.mode = name;
      name === 'erase' ? this.opacity = 1 : this.opacity = 10
    },
    updateScale(data) {
      const maxScale = 3; // 最大缩放比例
      const minScale = 0.2; // 最小缩放比例
      if (data) {//放大
        if (this.scale < maxScale) {
          this.scale += 0.2; // 每次缩放的增量
          if (this.scale >= 3) {
            this.scale = 3
          }
        }
      } else {//缩小\
        if (this.scale > minScale) {
          this.scale -= 0.2; // 最小缩放比例
        }
      }
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`
    },
    updateScreenSize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
      // console.log(this.screenWidth,this.screenHeight);

    },
    saveImage() {
      let _this = this
      setTimeout(() => {
        const canvas = this.$refs.canvasDisplay;
        // 获取mask
        canvas.toBlob((blob) => {
          // console.log(blob);
          const file = new File([blob], 'my-drawing.png', {type: 'image/png'})
          const formData = new FormData();
          formData.append('file', file,);
          _this.$http.post(_this.fileApi + '/api/front/upload/?fdir=mj_tool', formData).then(res => {
            _this.form.data.iw_urls = res.data.file_full_url
            _this.isDrowShow = false
            _this.clearMaskShow = true

          })
        })
      });
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },

    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)

    },

    handleDocumentClick(event) {
      // 判断点击的区域是否是 container 元素或其子元素
      if (this.$refs.container && !this.$refs.container.contains(event.target)) {
        // 点击了除 container 以外的区域，执行相应操作
        this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
      }
    },
    getProfile() {
      this.$http.get(`${MAIN_URLROOT}/api/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
        }
      }).finally(() => {
      })
    },
    //发送消息
    sendMsg() {
      if (!this.checkLogin()) return
      if(!utils.setOptData(this.userInfo,'btn_aitool_create')){
          return
      }
      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      if (this.form.data.iw_url === '') {
        this.$message.warning('请上传图片')
        return
      }
      // 同步请求
      this.submitQuestion(this.form);
    },
    submitQuestion(data, parent_msg_code, i) {
      this.sending = true;
      // 提交问题
      data.source = "pc";
      this.$http.post('/front/aimj/mjtools/', data).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          this.getProfile()
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              console.log('进入会员中心')
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    // 上传图片
    UpdataSuccess(res, file) {
      if (res.data.error !== '') {
        this.$message.error(res.data.error)
        return
      }
      // this.form.data.iw_url = res.data.file_full_url;
      this.form.data.iw_url = res.data.file_full_url;
      this.form.data.iw_urls = ''
      this.openRemoval()
      this.drawnPath = []
    },
    beforeUpload(file) {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      let _this = this
      const isLt3M = file.size / 1024 / 1024 < 5;
      const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const {width, height} = img;
          const isValidResolution = width <= 4096 && height <= 4096;
          this.originHeight = height
          this.originWidth = width

          if (!isValidType) {
            this.$message.error('只能上传 JPG/JPEG/PNG/BMP/WEBP 格式的文件!');
            reject({isValidType: false});
            return
          }

          if (!isLt3M) {
            this.$message.error('上传文件大小不能超过 5MB!');
            reject({isLt3M: false});
            return
          }

          if (!isValidResolution) {
            this.$message.error('图片分辨率需小于 4096x4096 像素!');
            reject({isValidResolution: false});
            return
          }

          resolve({isValidType, isLt3M, isValidResolution,});
        };
        img.onerror = () => {
          this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
          reject({isImageValid: false});
        };
      });
    },
    openRemoval() {
      // 打开弹窗
      // this.$refs.imgRemovalPopup.show()
      this.isDrowShow = true
      this.$nextTick(() => {
        // this.loadImage()
        this.drawImage()
      });
    },
    drawImage() {
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');
      const naturalWidth = this.originWidth;
      const naturalHeight = this.originHeight;
      const maxDimension = this.screenWidth; // 最大宽高限制
      const canvas2 = this.$refs.canvasDisplay
      this.canvasDisplay = canvas2.getContext('2d');
      this.scale = 1; // 初始缩放比例
      if (naturalWidth > maxDimension || naturalHeight > maxDimension) {
        const widthScale = maxDimension / naturalWidth;
        const heightScale = maxDimension / naturalHeight;
        this.scale = Math.min(widthScale, heightScale);
        // scale = Math.max(widthScale, heightScale);
      } else {
        this.scale = 1; // 如果图片尺寸小于限制，则保持原始大小
      }
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`

      this.enableDrawing();
      this.brushSize = 15
    },
    drawCircle(ctx, x, y, col = 'rgba(0, 255, 0, 0.5)', w, h) {
      ctx.globalCompositeOperation = 'source-over'
      this.canvasDisplay.beginPath();
      this.canvasDisplay.arc(x, y, this.brushSize, 0, Math.PI * 2); // 绘制一个半径为 10 的圆形
      this.canvasDisplay.fillStyle = col; // 绿色半透明
      this.canvasDisplay.fill();
      this.canvasDisplay.closePath();

    },
    clearCanvas() {
      // 清除整个画布
      const canvas = this.$refs.canvasRecord;
      const canvas2 = this.$refs.canvasDisplay;
      // const canvas3 = this.$refs.yesMask
      // this.canvasRecord.clearRect(0, 0, canvas.width, canvas.height);
      this.canvasDisplay.clearRect(0, 0, canvas.width, canvas.height);
      // this.canvasYesMask.clearRect(0, 0, canvas3.width, canvas3.height);
      this.drawnPath = []
      // this.loadImage()
      this.drawImage()
      this.mode = 'draw'
    },
    enableDrawing(ctx) {
      let _this = this
      let isDrawing = false;
      const canvas2 = this.$refs.canvasDisplay;
      // const canvasYes = this.$refs.yesMask;
      this.canvasDisplay = canvas2.getContext('2d');
      // this.canvasYesMask = canvasYes.getContext('2d')
      // 鼠标画板按下
      canvas2.addEventListener('pointerdown', (e) => {
        isDrawing = true;
        this.canvasDisplay.beginPath();
        this.canvasDisplay.moveTo(e.offsetX, e.offsetY);
      });

      // 鼠标画板移动
      canvas2.addEventListener('pointermove', (e) => {
        if (isDrawing == true && this.mode != 'erase') {
          this.drawnPath.push({x: e.offsetX, y: e.offsetY})
          _this.drawCircle(_this.canvasDisplay, e.offsetX, e.offsetY, 'rgba(0, 255, 0, 0.5)');
        }
        // console.log('mousemove')
        if (this.mode == 'erase' && isDrawing) {
          let qingx = e.offsetX
          let qingy = e.offsetY
          _this.clearPath.push({x: e.offsetX, y: e.offsetY})
          _this.erase(_this.canvasDisplay, qingx, qingy)
        }
        e.preventDefault()
      });
      // 鼠标画板松开
      canvas2.addEventListener('pointerup', () => {
        if (!isDrawing) return
        isDrawing = false;
        // console.log('mouseup')
        // 在下面的画板上操作
        // this.drawPathOnResult(this.canvasYesMask,canvas2.width,canvas2.height)
      });
    },
    erase(ctx, x, y, w, h) {
      const brushSize = this.brushSize;
      ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
      ctx.beginPath();
      ctx.arc(x, y, brushSize, 0, Math.PI * 2); // 绘制一个圆形
      ctx.fill(); // 填充圆形，实现擦拭效果
      this.clearRea(x, y)
      // ctx.globalCompositeOperation = 'source-over'; // 恢复默认模式
      if (w && h) {
        const largeWidth = w;
        const largeHeight = h;
        const smallWidth = this.$refs.originImg.width;
        const smallHeight = this.$refs.originImg.height;

        // 计算缩放比例
        const scaleX = smallWidth / largeWidth;
        const scaleY = smallHeight / largeHeight;
        const brushSize = this.brushSize;
        ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
        ctx.beginPath();
        ctx.arc(x, y * scaleY + this.changeNum, brushSize, 0, Math.PI * 2); // 绘制一个圆形
        ctx.fill(); // 填充圆形，实现擦拭效果
        // this.clearRea(x,y)
      }
    },
    clearRea(x, y) {
      let r = this.brushSize
      this.drawnPath.forEach((item, index) => {
        if ((item.x >= x - r && item.x <= x + r) && (item.y >= y - r && item.y <= y + r)) {
          this.drawnPath.splice(index, 1)
        }
      })
    },
  },

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.yesUpload {
  width: 100%;
  height: 140px;
  position: relative;
}

.yesUpload_img, .yesUploadMask {
  position: absolute;
  width: 140px;
  height: 140px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.yesUpload_icon {
  position: absolute;
  right: 8px;
  bottom: 5px;
  //background-color: aquamarine;
  color: #FFF;
  font-size: 13px;
  background-color: #5865f2;
  padding: 3px 5px;
  border-radius: 5px;
  z-index: 2;

}

.yesUploadMask {
  z-index: 1;
}

.needSubImg {
  position: fixed;
  top: 0;
  left: 0;
}

.drowPopB {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}


.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
  display: flex;
  //align-items: center;
  //justify-content: center;
}

.imgRemovalPopup {
  width: 100%;
  margin-top: 40px;
  padding: 20px 15px;
  //background-color: #000000;
  background-color: rgb(30, 31, 34);
  border-radius: 10px;
  // height: 500px;
  font-size: 14px;
  color: #fafafa;
  overflow: hidden;

  .imgbox_top {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 700;
  }

  .imgbox_center {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 20px 0;
    position: relative;

    .apply {
      display: flex;

      span {
        display: block;
        width: 100px;
        padding: 8px 0;
        text-align: center;
        background-color: #31374a;
        border-radius: 5px;
        border: 2px solid #31374a;
        cursor: pointer;
      }

      .spancol {
        border: 2px solid #04c066;
      }
    }

    .brush {
      display: flex;
      align-items: center;
      position: relative;
      // .aocText{
      //   position: absolute;
      //   top: -5px;
      //   left: 50%;
      //   transform: translateX(-50%);
      // }
      .addBtn {
        width: 20px;
        height: 20px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .slider {
        width: 100px;
        margin: 0 10px;
      }
    }

    .scoBox {
      display: flex;
      justify-content: space-between;
      width: 140px;
    }

    .scoleBox {
      display: flex;
      align-items: center;

      .scoText {
        margin-right: 10px;
      }

      .scoBtn {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #fff;
        background: #919090;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    .clear_btn {
      position: absolute;
      top: 17px;
      right: -20px;

      div {
        padding: 8px 20px;
        margin: 0 20px 0 0;
        text-align: center;
        background-color: #31374a;
        border-radius: 5px;
        border: 2px solid #31374a;
        cursor: pointer;
      }
    }

  }

  .canvas_region {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    background: rgb(20, 24, 36);

    .canvas-wrapper {
      position: relative;
      width: calc(100vw - 30px);
      height: 50vh;
      overflow: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      // background-color: #f0f0f0; /* 可选的背景色 */
      // flex-direction: column;
      font-size: 0 !important;

      &::-webkit-scrollbar {
        width: 0px; /* 设置滚动条宽度 */
        height: 0px; /* 设置滚动条高度，对于水平滚动条有效 */
      }
    }

    #imageOrigin {
      position: absolute;
      transform-origin: center; /* 设置缩放中心 */
      transform: scale(1); /* 初始缩放比例 */
      transition: transform 0.3s ease; /* 动画效果 */
      max-width: none !important;
    }

    #canMask {
      position: absolute;
      transform-origin: center;
      transform: scale(1); /* 初始缩放比例 */
      transition: transform 0.3s ease;
    }

    .canvas_box {
      position: relative;
      font-size: 0 !important;
      // width: 600px;
      // height: 600px;
      /* overflow: hidden; */
      display: flex;
      justify-content: center;
      align-items: center;

      .canvas_img {
        // max-width: 600px;
        height: 100%;

      }

      .canvas_imgs {
        // max-width: 600px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        //border: 1px solid #000;
        // background: transparent;
        background-size: cover; /* 使背景图像覆盖整个canvas */
        background-position: center; /* 将背景图像居中 */
        background-repeat: no-repeat; /* 防止背景图像重复 */
      }
    }

  }

  .complete_btn {
    padding: 10px 0;
    border-top: 1px solid #353639;

    div {
      margin: 0 auto;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      white-space: nowrap;
      user-select: none;
      height: 36px;
      width: 40%;
      border-radius: 4px;
    }
  }
}


#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    overflow: hidden;
    flex: 1 1 0%;

    .form_wrap {
      overflow-y: auto;
      padding: 5px 15px 15px;
      height: 100%;
    }

    .options_item {
      margin: 10px 0 10px;

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      // 上传参考图
      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;
        box-sizing: border-box;

        .upload-demo {
          width: 100%;
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }
      }
    }
  }

  .bottom_area {
    //background-color: #2b2d31;
    //height: 90px;
    //width: 100%;
    //padding: 0 30px;
    //position: fixed;
    //bottom: 60px;

    background-color: #2b2d31;
    height: 90px;
    width: 100%;
    padding: 0 30px;

    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;

      span {
        font-size: 12px;
      }
    }
  }
}

.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .centerPanel {
    position: fixed;
    z-index: 1501;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s;
  }
}

/deep/ .el-loading-mask {
  background: none;
}
</style>